module.exports = __webpack_public_path__ + "static/charlie-munger-cc1e350bb3cfb1ec3bccc95232a89a72.jpg";